/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import './layout.css'
import 'fontsource-ubuntu'
import 'fontsource-ubuntu/300.css'
import 'fontsource-ubuntu/400.css'
import 'fontsource-ubuntu/500.css'
import 'fontsource-ubuntu/700.css'

import { graphql, useStaticQuery } from 'gatsby'

import Footer from './Footer'
import Header from './Header'
import PropTypes from 'prop-types'
import React from 'react'

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <div className='font-sans bg-gray-900'>
        <Header/>
        <main>{children}</main>
        <Footer/>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
